/** Darstellung der Laufansicht „Kampagne gestartet“ (Design: `run()`), rein und testbar. */

import { RunStep } from '../campaign-wizard.types';

export interface RunStepView {
  icon: 'check_circle' | 'autorenew' | 'radio_button_unchecked';
  iconColor: string;
  titleColor: string;
  spin: boolean;
  /** Fortschrittsbalken in % (nur bei aktiven Schritten mit Fortschritt). */
  barPercent: number | null;
  approveButton: boolean;
}

export const runStepView = (step: RunStep): RunStepView => {
  const barPercent =
    step.state === 'active' && typeof step.progress === 'number'
      ? Math.max(0, Math.min(100, Math.round(step.progress)))
      : null;
  if (step.state === 'done') {
    return {
      icon: 'check_circle',
      iconColor: '#4F44FF',
      titleColor: '#1C1C1C',
      spin: false,
      barPercent: null,
      approveButton: false,
    };
  }
  if (step.state === 'active') {
    return {
      icon: 'autorenew',
      iconColor: '#4F44FF',
      titleColor: '#1C1C1C',
      spin: true,
      barPercent,
      approveButton: Boolean(step.approveButton),
    };
  }
  return {
    icon: 'radio_button_unchecked',
    iconColor: '#C9CCD3',
    titleColor: '#707070',
    spin: false,
    barPercent: null,
    approveButton: false,
  };
};

/** Pause/Fortsetzen: der Status kommt als Backend-Wert (`active`/`started`/`paused`). */
export const isPaused = (status: string): boolean => status === 'paused';

export type RunStatusKey = 'working' | 'paused' | 'other';

export const runStatusKey = (status: string): RunStatusKey =>
  status === 'active' || status === 'started' || status === 'running'
    ? 'working'
    : status === 'paused'
      ? 'paused'
      : 'other';

export const approvalLabelKey = (pending: number): 'wizRunPending' | 'wizRunNothing' =>
  pending > 0 ? 'wizRunPending' : 'wizRunNothing';
